module.exports = __webpack_public_path__ + "static/media/header.3986f38f.png";